if (!customElements.get('jr-seasonal-gifts')) {
  customElements.define('jr-seasonal-gifts', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const tabs = [...this.querySelectorAll('[data-season]')];
      const panels = [...this.querySelectorAll('.jr-native-gift')];
      const choose = (tab) => {
        tabs.forEach(item => item.setAttribute('aria-pressed', String(item === tab)));
        panels.forEach(panel => panel.hidden = panel.id !== tab.getAttribute('aria-controls'));
      };
      if (tabs.length) {
        this.querySelector('.jr-native-seasons').hidden = false;
        tabs.forEach(tab => tab.addEventListener('click', () => choose(tab)));
        choose(tabs.find(tab => tab.dataset.season === 'autumn') || tabs[0]);
      }
      this.querySelectorAll('[data-add-gift]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', async () => {
          if (button.disabled) return;
          const panel = button.closest('.jr-native-gift');
          const status = panel.querySelector('[data-gift-status]');
          const items = [...panel.querySelectorAll('[data-gift-variant]')].map(input => ({ id: input.value, quantity: 1 }));
          button.disabled = true;
          status.textContent = 'Adding your selection…';
          try {
            const response = await fetch(this.dataset.addUrl, { method: 'POST', headers: {'Content-Type':'application/json', 'Accept':'application/json'}, body: JSON.stringify({items}) });
            const result = await response.json();
            if (!response.ok) {
              status.textContent = typeof result.description === 'string' ? result.description : 'This selection is not available. Please review your basket.';
              button.disabled = false;
              return;
            }
            window.location.assign(this.dataset.cartUrl);
          } catch {
            // The request might have reached Shopify. Do not automatically retry.
            status.replaceChildren(document.createTextNode('We could not confirm the update. '));
            const link = document.createElement('a');
            link.href = this.dataset.cartUrl;
            link.textContent = 'Check your basket before adding again.';
            status.append(link);
          }
        });
      });
    }
  });
}
